module.exports = function (app, mod) {
  return "<div class=\"gameboard\"></div>";
};